import { render } from "./PhotoComponent.vue?vue&type=template&id=4a305b72&scoped=true"
import script from "./PhotoComponent.vue?vue&type=script&lang=js"
export * from "./PhotoComponent.vue?vue&type=script&lang=js"

import "./PhotoComponent.vue?vue&type=style&index=0&id=4a305b72&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a305b72"]])

export default __exports__